import axios from "axios";
import { isEmpty } from "./validators";

export const fetchUrl = (url) => {
  // const baseUrl = `${process.env.REACT_APP_API_GATEWAY_URL}/${url}`;
  const baseUrl = `https://prod-api.astrocure.co.in/api/v1/${url}`;
  return baseUrl;
};

export const setAuthorization = (token) => {
  if (!isEmpty(token)) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    if (
     (error.response?.status === 401 || error.response?.status === 403) &&
      originalRequest &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refreshToken");

      return new Promise((resolve, reject) => {
        axios
          .post(fetchUrl("auth/refresh-token"), { refreshToken })
          .then(({ data }) => {
            const newAccessToken = data.accessToken || data.data?.accessToken;

            if (!newAccessToken) {
              throw new Error("No access token in refresh response");
            }

            setAuthorization(newAccessToken);
            localStorage.setItem("accessToken", newAccessToken);

            processQueue(null, newAccessToken);
            originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;

            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            setAuthorization(null);
            window.location.href = '/';
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);
